import { render } from "./TeamsCardLarge.vue?vue&type=template&id=63824e83"
import script from "./TeamsCardLarge.vue?vue&type=script&lang=js"
export * from "./TeamsCardLarge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__